/* ==============================================
   FILTER ENHANCEMENTS JS - Horizon Theme v6
   Exact selectors from inspector
   ============================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* -------------------------------------------------
     FEATURE 9: SEARCH WITHIN FILTERS
     ================================================- */
  function addFilterSearch() {
    var groups = document.querySelectorAll('accordion-custom.facets__item');

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];

      // Skip if search already added
      if (group.querySelector('.filter-search-input')) continue;

      // Find the floating panel content
      var panel = group.querySelector('floating-panel-component');
      if (!panel) continue;

      var list = panel.querySelector('ul');
      if (!list) continue;

      var items = list.querySelectorAll('li');
      if (items.length < 5) continue;

      // Create search input
      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'filter-search-input';
      input.placeholder = 'Search...';

      // Insert before the list
      panel.insertBefore(input, list);

      // Closure for event listener
      (function(searchInput, listItems) {
        searchInput.addEventListener('input', function () {
          var q = this.value.toLowerCase().trim();
          for (var j = 0; j < listItems.length; j++) {
            var text = listItems[j].textContent.toLowerCase();
            if (q === '' || text.indexOf(q) !== -1) {
              listItems[j].classList.remove('filter-hidden');
            } else {
              listItems[j].classList.add('filter-hidden');
            }
          }
        });
      })(input, items);
    }
  }

  function collapseAllFilters() {
    var groups = document.querySelectorAll('accordion-custom.facets__item');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.querySelector('input:checked')) {
        var details = group.querySelector('details.facets__panel');
        if (details) details.removeAttribute('open');
      }
    }
  }

  function createActiveFiltersBar() {
    var removeLinks = document.querySelectorAll('.facets-remove a, .facets-remove--mobile-and-vertical a');
    if (removeLinks.length === 0) return;

    var existing = document.querySelector('.active-filters-bar');
    if (existing) existing.remove();

    var grid = document.querySelector('.collection-grid, .product-grid, [class*="product-grid"], main.content-for-layout section');
    if (grid) {
      var bar = document.createElement('div');
      bar.className = 'active-filters-bar';
      var label = document.createElement('span');
      label.className = 'active-filters-bar__label';
      label.textContent = 'Active Filters:';
      bar.appendChild(label);

      var tagCount = 0;
      for (var i = 0; i < removeLinks.length; i++) {
        var text = removeLinks[i].textContent.trim().replace(/✕|×|Remove|remove/g, '').trim();
        if (text) {
          var tag = document.createElement('a');
          tag.className = 'active-filter-tag';
          tag.href = removeLinks[i].href || '#';
          tag.innerHTML = text + ' <span class="active-filter-tag__remove">✕</span>';
          bar.appendChild(tag);
          tagCount++;
        }
      }
      if (tagCount > 0) grid.parentNode.insertBefore(bar, grid);
    }
  }

  setTimeout(function () {
    collapseAllFilters();
    addFilterSearch();
    createActiveFiltersBar();
  }, 800);

  var wrapper = document.querySelector('div.facets__filters-wrapper');
  if (wrapper) {
    var observer = new MutationObserver(function () {
      setTimeout(function () {
        addFilterSearch();
        createActiveFiltersBar();
      }, 500);
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  }

});

document.addEventListener('DOMContentLoaded', function () {
  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) return;

  function addContinueShoppingButton() {
    // Don't add if already exists
    if (document.querySelector('.continue-shopping-btn')) return;

    // Find the buy buttons block
    var buyBlock = document.querySelector('.buy-buttons-block');
    if (!buyBlock) return;

        // Create the button
                    var btn = document.createElement('a');
                    btn.className = 'continue-shopping-btn';
                    btn.href = '#';
                    btn.setAttribute('aria-label', 'Continue Shopping');
                    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18"/></svg> Continue Shopping';

                    btn.addEventListener('click', function (e) {
                      e.preventDefault();
                              if (document.referrer && document.referrer.indexOf(window.location.hostname) !== -1) {
                                window.history.back();
                              } else {
                                window.location.href = '/collections/all';
                              }
                    });

    // Insert after buy buttons block
        buyBlock.parentNode.insertBefore(btn, buyBlock.nextSibling);
      }

      // Run on load and also observe for dynamic content
        setTimeout(addContinueShoppingButton, 500);
        setTimeout(addContinueShoppingButton, 1500);
});

/* ==============================================
   FEATURE: AUTO-EXPAND ALL FILTER VALUES
   Ensures all brands show without clicking Show more
   Categories auto-populate when brand is selected
   New products/brands appear automatically via
   the Vendor field and MutationObserver
   ============================================== */
document.addEventListener('DOMContentLoaded', function () {

  function expandAllFilterShowMore() {
    var btns = document.querySelectorAll('.show-more__button');
    btns.forEach(function (btn) {
      if (btn.getAttribute('aria-expanded') !== 'true') {
        var component = btn.closest('show-more-component');
        if (component && component.querySelectorAll('li.hidden').length > 0) {
          btn.click();
        }
      }
    });
  }

  function openBrandAndCategoryFilters() {
    var groups = document.querySelectorAll('accordion-custom.facets__item');
    groups.forEach(function (group) {
      var details = group.querySelector('details.facets__panel');
      if (!details) return;
      var summary = details.querySelector('summary');
      if (!summary) return;
      var label = summary.textContent.trim().toUpperCase();
      if (label.indexOf('BRAND') !== -1 || label.indexOf('CATEGORY') !== -1) {
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
      }
    });
  }

  function runEnhancements() {
    expandAllFilterShowMore();
    openBrandAndCategoryFilters();
  }

  setTimeout(runEnhancements, 700);
  setTimeout(runEnhancements, 1600);

  var wrapper = document.querySelector('div.facets__filters-wrapper');
  if (wrapper) {
    var obs = new MutationObserver(function () {
      setTimeout(runEnhancements, 400);
    });
    obs.observe(wrapper, { childList: true, subtree: true });
  }

});

// Cart login link - make "Log in to view pricing" clickable
(function() {
  if (document.body.classList.contains('customer-logged-in')) return;
    var injected = false;
      function addLoginLink() {
          if (injected) return;
              var drawer = document.querySelector('.cart-drawer__content');
                  if (!drawer) return;
                      injected = true;
                          var p = document.createElement('p');
                              p.id = 'cart-login-link';
                                  p.style.cssText = 'text-align:center;padding:1rem;font-style:italic;opacity:0.7;';
                                      var a = document.createElement('a');
                                          a.href = '/account/login';
                                              a.textContent = 'Log in to view pricing.';
                                                  p.appendChild(a);
                                                      drawer.insertBefore(p, drawer.firstChild);
                                                          var style = document.createElement('style');
                                                              style.textContent = 'body:not(.customer-logged-in) .cart-drawer__content::before{display:none!important}';
                                                                  document.head.appendChild(style);
                                                                    }
                                                                      var obs = new MutationObserver(addLoginLink);
                                                                        obs.observe(document.body, { childList: true, subtree: true });
                                                                          addLoginLink();
                                                                          })();

/* ============================================================
   BUG FIX JAVASCRIPT - Added by automated bug fix system
   ============================================================ */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    
    // BUG-005: Add H1 to homepage if missing
    if (window.location.pathname === '/' || window.location.pathname === '') {
      const h1 = document.querySelector('h1');
      if (!h1) {
        // Find the main hero section and inject an accessible H1
        const heroText = document.querySelector('.hero__heading, [class*="hero"] [class*="title"], [class*="banner"] [class*="title"], .banner__heading');
        // Always inject H1 on homepage since no hero selector found
        const hiddenH1 = document.createElement('h1');
        hiddenH1.textContent = 'The I.T. Factory | Professional AV & IT Solutions | Charleston, SC';
        hiddenH1.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
        const main = document.querySelector('main') || document.querySelector('#MainContent');
        if (main) main.insertBefore(hiddenH1, main.firstChild);
      }
    }

    // BUG-022: Add H1 to collection page if missing (not counting Filters H1 from Rapid Search)
    if (window.location.pathname.startsWith('/collections/')) {
      const meaningfulH1 = Array.from(document.querySelectorAll('h1')).find(h => 
        !h.className.includes('facets') && h.textContent.trim() !== 'Filters'
      );
      if (!meaningfulH1) {
        // Use document title as collection name (remove store suffix)
        const collTitle = document.title.split(' –')[0].split(' -')[0].split(' |')[0].trim();
        if (collTitle && collTitle !== 'The I.T. Factory') {
          const hiddenH1 = document.createElement('h1');
          hiddenH1.textContent = collTitle;
          hiddenH1.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
          const main = document.querySelector('main') || document.querySelector('#MainContent');
          if (main) main.insertBefore(hiddenH1, main.firstChild);
        }
      }
    }

    // BUG-033: Product title - ensure H1 on product pages
    if (window.location.pathname.startsWith('/products/')) {
      const meaningfulProdH1 = Array.from(document.querySelectorAll('h1')).find(h => 
        !h.className.includes('facets') && h.textContent.trim() !== 'Filters'
      );
      if (!meaningfulProdH1) {
        // Use document title as product name
        const prodTitle = document.title.split(' –')[0].split(' -')[0].split(' |')[0].trim();
        if (prodTitle) {
          const hiddenH1 = document.createElement('h1');
          hiddenH1.textContent = prodTitle;
          hiddenH1.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
          const main = document.querySelector('main') || document.querySelector('#MainContent');
          if (main) main.insertBefore(hiddenH1, main.firstChild);
        }
      }
    }

    // BUG-044: Countdown timer ARIA live region
    const countdownTimers = document.querySelectorAll('[id*="countdown"], [class*="countdown"], [id*="timer"], [class*="timer"]');
    countdownTimers.forEach(timer => {
      if (!timer.getAttribute('aria-live')) {
        timer.setAttribute('aria-live', 'polite');
        timer.setAttribute('role', 'timer');
      }
    });

    // BUG-046: Footer heading hierarchy - H4 should be H3
    const footerH4s = document.querySelectorAll('footer h4');
    footerH4s.forEach(h4 => {
      const h3 = document.createElement('h3');
      h3.innerHTML = h4.innerHTML;
      h3.className = h4.className;
      // Copy all attributes
      Array.from(h4.attributes).forEach(attr => {
        if (attr.name !== 'class') h3.setAttribute(attr.name, attr.value);
      });
      h4.parentNode.replaceChild(h3, h4);
    });

    // BUG-043: Add aria-labels to links without accessible names
    const emptyLinks = document.querySelectorAll('a:not([aria-label]):not([aria-labelledby])');
    emptyLinks.forEach(link => {
      const text = link.textContent.trim();
      const img = link.querySelector('img');
      if (!text && img) {
        // Use alt text from image
        const alt = img.getAttribute('alt');
        if (!alt || alt === '') {
          // Set aria-label from href if possible
          const href = link.getAttribute('href') || '';
          if (href && href !== '#' && href !== '/') {
            const hrefLabel = href.split('/').pop().replace(/-/g, ' ').replace(/.[^.]+$/, '');
            if (hrefLabel) link.setAttribute('aria-label', hrefLabel);
          }
        }
      }
    });


    // BUG-047: Product image alt text - add position context to differentiate
    if (window.location.pathname.startsWith('/products/')) {
      const productImgs = document.querySelectorAll('.product__media img, [class*="product-media"] img, [class*="product__media"] img, .media img');
      if (productImgs.length > 1) {
        const baseAlt = productImgs[0]?.alt?.split(' - Image')[0] || '';
        productImgs.forEach((img, i) => {
          if (i === 0) return; // Keep first image alt as-is
          const currentAlt = img.alt || baseAlt;
          // Only add suffix if alt doesn't already have image number
          if (!currentAlt.includes('Image ') && !currentAlt.includes('- image')) {
            img.alt = currentAlt + ' - Image ' + (i + 1);
          }
        });
      }
    }

    // BUG-037: Show contact form success message when form submitted
    if (window.location.pathname === '/pages/contact' || window.location.pathname.includes('contact')) {
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('customer_posted') === 'true') {
        var successMsg = document.getElementById('itf-success-msg') || document.querySelector('.form-success-message');
        var contactForm = document.getElementById('contact_form') || document.querySelector('.contact-form');
        if (successMsg) {
          successMsg.style.display = 'block';
          if (contactForm) contactForm.style.display = 'none';
          setTimeout(function() {
            successMsg.scrollIntoView({behavior: 'smooth', block: 'center'});
          }, 100);
        }
      }
    }

    // BUG-023: Add breadcrumb navigation to product pages
    if (window.location.pathname.startsWith('/products/')) {
      // Create breadcrumb JSON-LD schema
      var productTitle = document.title.split(' – ')[0].trim();
      var breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem", "position": 1, "name": "Home", "item": window.location.origin},
          {"@type": "ListItem", "position": 2, "name": "Shop", "item": window.location.origin + "/collections/all"},
          {"@type": "ListItem", "position": 3, "name": productTitle, "item": window.location.href}
        ]
      };
      
      var existingBreadcrumb = document.querySelector('[data-breadcrumb],.breadcrumb,.breadcrumbs');
      if (!existingBreadcrumb) {
        // Add schema markup
        var schema = document.createElement('script');
        schema.type = 'application/ld+json';
        schema.textContent = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(schema);
        
        // Add visual breadcrumb
        var breadcrumbHTML = '<nav aria-label="Breadcrumb" class="breadcrumb-nav" style="padding:8px 20px;font-size:0.85em;color:#666;">' +
          '<ol style="list-style:none;padding:0;margin:0;display:flex;flex-wrap:wrap;gap:4px;" itemscope itemtype="https://schema.org/BreadcrumbList">' +
          '<li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">' +
          '<a href="/" itemprop="item" style="color:#1a1f5e;"><span itemprop="name">Home</span></a>' +
          '<meta itemprop="position" content="1">' +
          '</li>' +
          '<li style="color:#999;padding:0 4px;" aria-hidden="true">›</li>' +
          '<li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">' +
          '<a href="/collections/all" itemprop="item" style="color:#1a1f5e;"><span itemprop="name">Shop</span></a>' +
          '<meta itemprop="position" content="2">' +
          '</li>' +
          '<li style="color:#999;padding:0 4px;" aria-hidden="true">›</li>' +
          '<li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">' +
          '<span itemprop="name">' + productTitle + '</span>' +
          '<meta itemprop="position" content="3">' +
          '</li>' +
          '</ol>' +
          '</nav>';
        
        var main = document.querySelector('main, #MainContent');
        if (main) {
          main.insertAdjacentHTML('afterbegin', breadcrumbHTML);
        }
      }
    }
    // BUG-045: Skip link focus fix is handled via CSS


    // BUG-013: Fix missing alt text on brand logo images
    // Add alt text based on filename or parent link context
    const brandLogoImgs = document.querySelectorAll('[class*="ai-brands-image-wrapper"] img, [class*="brands-image"] img');
    brandLogoImgs.forEach(img => {
      if (!img.alt || img.alt === '') {
        // Try to get alt from parent anchor link
        const parentLink = img.closest('a');
        if (parentLink) {
          const linkText = parentLink.textContent.trim();
          if (linkText && linkText.length > 0 && linkText.length < 50) {
            img.alt = linkText + ' logo';
            return;
          }
          // Try from href
          const href = parentLink.getAttribute('href') || '';
          const brand = href.split('/').pop().replace(/-products?$/, '').replace(/-collection$/, '').replace(/-/g, ' ');
          if (brand) {
            img.alt = brand.charAt(0).toUpperCase() + brand.slice(1) + ' logo';
            return;
          }
        }
        // Try from filename
        const src = img.src || img.getAttribute('data-src') || '';
        const filename = src.split('/').pop().split('?')[0].split('.')[0];
        if (filename) {
          const cleaned = filename.replace(/_+/g, ' ').replace(/-+/g, ' ').replace(/logo/gi, '').replace(/\d+/g, '').trim();
          img.alt = cleaned.charAt(0).toUpperCase() + cleaned.slice(1) + ' logo';
        }
      }
    });

    // Fix alt text on header logo
    const headerLogo = document.querySelector('.header-logo__image-container img, .site-logo img, header img[class*="logo"]');
    if (headerLogo && (!headerLogo.alt || headerLogo.alt === '')) {
      headerLogo.alt = 'The I.T. Factory';
    }

    // Fix alt text on hero image
    const heroImg = document.querySelector('.hero__media-wrapper img');
    if (heroImg && (!heroImg.alt || heroImg.alt === '')) {
      heroImg.alt = 'The I.T. Factory - Professional AV & IT Solutions';
    }

  }); // end DOMContentLoaded

})(); // end IIFE


// NAV FIX v4: Remove slot=overflow attrs to keep all nav items visible
(function(){function fix(){var ol=document.querySelector('overflow-list.overflow-menu');if(!ol)return;ol.querySelectorAll('.menu-list__list-item[slot="overflow"]').forEach(function(li){li.removeAttribute('slot');});}var obs=null;function watch(){var ol=document.querySelector('overflow-list.overflow-menu');if(!ol){setTimeout(watch,50);return;}fix();if(obs)return;obs=new MutationObserver(function(muts){muts.forEach(function(m){if(m.attributeName==='slot')fix();});});obs.observe(ol,{attributes:true,subtree:true,attributeFilter:['slot']});}watch();setTimeout(watch,0);setTimeout(watch,50);setTimeout(watch,150);setTimeout(watch,300);setTimeout(watch,600);})();